import { render, staticRenderFns } from "./ProductCTA.vue?vue&type=template&id=4fbdc2fe&scoped=true&"
import script from "./ProductCTA.vue?vue&type=script&lang=js&"
export * from "./ProductCTA.vue?vue&type=script&lang=js&"
import style0 from "./ProductCTA.vue?vue&type=style&index=0&id=4fbdc2fe&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fbdc2fe",
  null
  
)

export default component.exports